<template>
    <v-container fluid>
        <sale-form
            :model="this.sale"
            @saved="saved"
            v-if="this.sale"
            class="mb-5 pa-2"
        />
    </v-container>
</template>

<script>
import Sale from '@/models/product/ProductSale'
import SaleForm from './Form'
export default {
    components: {
        SaleForm,
    },

    props: ['id'],

    data: () => {
        return {
            sale: null,
        }
    },

    computed: {
        model() {
            return new Sale()
        },
    },

    methods: {
        async getSale() {
            let item = await this.model.find(this.id)
            this.sale = item
        },

        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.getSale()
    },
}
</script>

<style></style>
